const actionTypes = {
    SET_SPONSOR_PRODUCTS: 'SET_SPONSOR_PRODUCTS',
    RESET_SPONSOR_PRODUCTS: 'RESET_SPONSOR_PRODUCTS',
    SET_SPONSOR_PRODUCTS_FAILURE: 'SET_SPONSOR_PRODUCTS_FAILURE'
};

module.exports = actionTypes;
